module.exports = new __parcel__URL__("albums.7403bd9c.webp").toString();